import { render, staticRenderFns } from "./RequiredDocumentsMessageApproveModal.vue?vue&type=template&id=7d04a4f4&scoped=true"
import script from "./RequiredDocumentsMessageApproveModal.vue?vue&type=script&lang=ts"
export * from "./RequiredDocumentsMessageApproveModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d04a4f4",
  null
  
)

export default component.exports